import React from 'react';
import { MediaPlayerError } from '@yi/core';

import { isMediaId } from '~/src/common/media';

import { useReportMediaPlaybackError } from './logger';

export const ReportPlaybackError: React.FC<{ mediaId: string }> = ({ mediaId }) => {
  const report = useReportMediaPlaybackError();
  if (!isMediaId(mediaId)) {
    report(new MediaPlayerError('invalid media id'));
  }

  return null;
};
